<template>
  <div>
    <div
      class="col-lg-12"
      style="padding-top: 20px; padding-bottom: 20px"
    ></div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <div class="row" style="display: flex">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                COLLECTION SCHEDULE
              </p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div style="width: 150px; display: flex">
                <div style="width: 6px; background-color: #0BAA00; color: #0BAA00">
                  .
                </div>
                &nbsp;&nbsp;&nbsp;
                <p
                  style="
                    font-size: 15px;
                    margin: auto;
                    font-weight: 300;
                    color: #A5A5A5;
                  "
                >
                  On Schedule
                </p>
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div style="width: 150px; display: flex">
                <div
                  style="width: 6px; background-color: #FFA827; color: #FFA827"
                >
                  .
                </div>
                &nbsp;&nbsp;&nbsp;
                <p
                  style="
                    font-size: 15px;
                    margin: auto;
                    font-weight: 300;
                    color: #A5A5A5;
                  "
                >
                  Delay
                </p>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="getBack()">Back</base-button
          >&nbsp;
          <base-button type="primary" v-on:click="getNext()">Next</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button
            class="btn-link"
            style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </base-button>
          <!-- <p
            style="cursor: pointer; color: #358CCB; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
import Card from "../../../../components/Cards/Card.vue";

export default {
  name: "CollectionSchedule",

  components: {
    Card,
  },

  data() {
    return {};
  },
  methods: {
    getDownload() {},

    getBack() {
      this.$router.push("/Outgoing");
    },

    getNext() {
      this.$router.push("/CollectionSchedule");
    },

    saveDraft() {
      console.log("save draft");
    },
  },
  created() {},
  computed: {},
};
</script>
<style></style>
